import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Autocomplete, Button, TextField } from '@mui/material'

export const TourPackageHotelForm = ({ hotels, tourPackageID }) => {
    // Отели берутся из родительского useForm
    const { register, watch, setValue, getValues, control } = useFormContext()

    const addHotel = () => {
        console.log('addHotel')
        const _hotels = getValues('hotels') || []
        setValue('hotels', [..._hotels, {
            TourToHotel: {
                hotelID: '',
                startDate: new Date(),
                toDate: new Date()
            }
        }], { shouldValidate: true })
    }

    const removeHotel = (index) => {
        const _hotels = getValues('hotels')
        setValue('hotels', _hotels.filter((_, i) => i !== index))
    }


    return (
        <div>
            <h3 className='m-b-16'>Проживание</h3>
            <section>
                {getValues('hotels').map((hotel, index) => {
                    return <div key={index} className='flex gap-8 w-100 m-b-16'>
                        <Controller
                            control={control}
                            name={`hotels[${index}].TourToHotel.hotelID`}
                            rules={{ required: true }}
                            render={({ field }) => {
                                return <Autocomplete
                                    className='flex-1'
                                    options={hotels}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => <TextField {...params} label="Отель" />}
                                    value={field?.value ? hotels.find(h => h.id === field.value) : null}                                    
                                    onChange={(event, value) => {
                                        field.onChange(value?.id)
                                    }}
                                />
                            }}
                        />
                        {/* Start date and end date */}
                        <TextField
                            className='flex-1'
                            type="date"
                            label="Дата заезда"
                            InputLabelProps={{
                                shrink: true, // 👈 prevents overlap
                            }}
                            {...register(`hotels[${index}].TourToHotel.startDate`, { required: true })}
                        />
                        <TextField
                            className='flex-1'
                            type="date"
                            label="Дата выезда"
                            InputLabelProps={{
                                shrink: true, // 👈 prevents overlap
                            }}
                            {...register(`hotels[${index}].TourToHotel.endDate`, { required: true })}
                        />
                        {!tourPackageID && <Button type="button" onClick={() => removeHotel(index)}> Удалить отель</Button>}
                    </div>
                })}
            </section>
            <section>
                <Button type="button" onClick={addHotel}>Добавить отель</Button>
            </section>
        </div>
    )
}
